export const range = (from: number, to: number, by: number = 1) => {
  return Array(Math.ceil((to - from + 1) / by))
    .fill(0)
    .map((item, index) => from + index * by)
}
